import { createSlice } from "@reduxjs/toolkit";
import { activateDeactivateCrawl, addCrawl, deleteCrawl, fetchCrawl, fetchCrawlTableColumnNames, updateCrawl } from "./thunk";

const initialState = {
  crawl: [],
  tableColumnNames: [],
  loading: false,
  error: null
};

const CrawlSlice = createSlice({
  name: "Crawl",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    // Fetch Human Categories Table Column Names
    .addCase(fetchCrawlTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchCrawlTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchCrawlTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchCrawl.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchCrawl.fulfilled, (state, action) => {
        state.loading = false;
        state.crawl = action.payload;
    })
    .addCase(fetchCrawl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(addCrawl.pending, (state) => {
        state.error = null;
    })
    .addCase(addCrawl.fulfilled, (state, action) => {
        state.crawl.unshift(action.payload);
    })
    .addCase(addCrawl.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(updateCrawl.pending, (state) => {
        state.error = null;
    })
    .addCase(updateCrawl.fulfilled, (state, action) => {
        const index = state.crawl.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.crawl[index] = action.payload;
        }
    })
    .addCase(updateCrawl.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(deleteCrawl.pending, (state) => {
        state.error = null;
    })
    .addCase(deleteCrawl.fulfilled, (state, action) => {
        state.crawl = state.crawl.filter(
            (item) => item.ID !== action.payload[0].ID
        );
    })
    .addCase(deleteCrawl.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(activateDeactivateCrawl.pending, (state) => {
        state.error = null;
    })
    .addCase(activateDeactivateCrawl.fulfilled, (state, action) => {
        const index = state.crawl.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.crawl[index] = action.payload;
        }
    })
    .addCase(activateDeactivateCrawl.rejected, (state, action) => {
        state.error = action.payload;
    })

  },
});

export default CrawlSlice.reducer;
